import { useAuth } from "../context/AuthContext";
import { Building2, Radio, Plane, Wallet, Users2, UserCog2, FileStack, LayoutDashboard, Check } from "lucide-react";

const MODULES = [
  { name: "Real Estate Portfolio", desc: "Properties, tenants, leases & financials", icon: Building2, active: true },
  { name: "Kora Finance", desc: "Accounting & cash management", icon: Wallet, active: false },
  { name: "Kora CRM", desc: "Leads, contacts & pipeline", icon: Users2, active: false },
  { name: "Kora Investors", desc: "Investor relations & distributions", icon: Radio, active: false },
  { name: "Kora Acquisitions", desc: "Deal pipeline & underwriting", icon: Plane, active: false },
  { name: "Kora HR", desc: "People & payroll", icon: UserCog2, active: false },
  { name: "Kora Documents", desc: "Enterprise document control", icon: FileStack, active: false },
  { name: "Kora Executive Dashboard", desc: "Cross-entity KPIs", icon: LayoutDashboard, active: false },
];

export default function Settings() {
  const { user } = useAuth();
  return (
    <div className="space-y-8" data-testid="page-settings">
      <div>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Settings</h1>
        <p className="text-sm text-muted-foreground mt-1">Account & platform configuration</p>
      </div>

      <section className="rounded-2xl border border-border bg-card p-6">
        <h2 className="font-heading font-semibold mb-4">Account</h2>
        <div className="grid sm:grid-cols-2 gap-4 text-sm">
          <div><p className="text-muted-foreground text-xs uppercase tracking-wider">Name</p><p className="font-medium mt-1">{user?.name}</p></div>
          <div><p className="text-muted-foreground text-xs uppercase tracking-wider">Email</p><p className="font-medium mt-1">{user?.email}</p></div>
          <div><p className="text-muted-foreground text-xs uppercase tracking-wider">Role</p><p className="font-medium mt-1 capitalize">{user?.role}</p></div>
          <div><p className="text-muted-foreground text-xs uppercase tracking-wider">Plan</p><p className="font-medium mt-1">Kora Holding, LLC — Pro</p></div>
        </div>
      </section>

      <section>
        <h2 className="font-heading font-semibold mb-1">Kora Modules</h2>
        <p className="text-sm text-muted-foreground mb-4">Kora Holding, LLC is modular. Additional modules can be enabled as you grow.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {MODULES.map((m) => (
            <div key={m.name} className={`rounded-2xl border p-5 ${m.active ? "border-primary/40 bg-primary/5" : "border-border bg-card"}`} data-testid={`module-${m.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <div className="flex items-center justify-between mb-3">
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${m.active ? "bg-gradient-to-br from-blue-500 to-emerald-500 text-white" : "bg-muted text-muted-foreground"}`}>
                  <m.icon className="w-5 h-5" strokeWidth={1.75} />
                </div>
                {m.active
                  ? <span className="flex items-center gap-1 text-xs font-semibold text-emerald-600"><Check className="w-3.5 h-3.5" /> Active</span>
                  : <span className="text-xs text-muted-foreground bg-muted px-2 py-1 rounded-md">Coming soon</span>}
              </div>
              <p className="font-heading font-semibold">{m.name}</p>
              <p className="text-sm text-muted-foreground mt-0.5">{m.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
